import React from 'react';
import { ReviewTileWrapper, ReviewSkeleton } from './styled';
import { AddressBlock, CustomerDataAddress } from 'components';
import { ReviewTileHeader } from './styled/index';
import { showIfOrElse } from 'helpers/conditionals';
import useTrackComponentLoadTime from '../../analytics/itly/hooks/useTrackComponentLoadTime';
import { TrackingProp } from 'react-tracking';
import { ComponentName } from 'constants/componentName';

export interface ReviewAddressTileProps {
  address: CustomerDataAddress;
  isLoading: boolean;
  tracking: TrackingProp;
  cartId: number;
  handleChangeClick?: () => void;
}

const ReviewAddressTile = ({ address, isLoading, tracking, cartId, handleChangeClick }: ReviewAddressTileProps): React.JSX.Element => {
  useTrackComponentLoadTime({
    isLoading,
    tracking,
    cartId,
    componentName: ComponentName.SHIPPING_ADDRESS
  });

  return (
    <ReviewTileWrapper>
      <ReviewTileHeader secondary>Shipping Address</ReviewTileHeader>
      {showIfOrElse(isLoading)(<ReviewSkeleton />)(
        <>
          <AddressBlock address={address} />
          {handleChangeClick && <button onClick={handleChangeClick}>change</button>}
        </>
      )}
    </ReviewTileWrapper>
  );
};

export default ReviewAddressTile;
